// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DomainRelevance\ApiDomainRelevance.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';
import { Event, EventData, EventOptions } from 'data/models/Event';

// DomainRelevanceData is the class that DomainRelevance serializes to/from
export interface DomainRelevanceData {
    DomainId : number;
    EventId : number;
	
    Domain : DomainData | null;
    Event : EventData | null;
	
}

// DomainRelevanceOptions is the class which may be passed to the DomainRelevance constructor to define optional initial data values
export interface DomainRelevanceOptions {
    DomainId : number;
    EventId : number;
	
    Domain? : DomainOptions | null;
    Event? : EventOptions | null;
	
}

export class DomainRelevance {
    public DomainId : DataSignal<number>;
    public EventId : DataSignal<number>;
	
    public Domain : DataSignal<Domain | null>;
    public Event : DataSignal<Event | null>;
	

    constructor();
    constructor(data : DomainRelevanceOptions);
    constructor(data: DomainRelevanceOptions | null = null) {
        this.DomainId = jsonableObservable(S.value<number>(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
	    
        this.Domain = S.value<Domain | null>(null);
        this.Event = S.value<Event | null>(null);
	    
    }

    static key(obj : DomainRelevance) {
        return obj.DomainId() + '\u2618' + obj.EventId();
    }
    
    static dataKey(obj : DomainRelevanceOptions) {
        return obj.DomainId + '\u2618' + obj.EventId;
    }

    static update(obj : DomainRelevance, data : DomainRelevanceOptions) {
        S.freeze(() => {
            if (data.DomainId !== undefined) obj.DomainId(data.DomainId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DomainRelevance.ts